import React from "react";
import styled from "styled-components";
import { useIntl } from "gatsby-plugin-intl";
import get from "lodash/get";
import { graphql } from "gatsby";

import ImageDescription from "Components/common/imageDescription";

const StyledWrapper = styled.div`
  padding: 3rem 1rem;
`;

const StyledTitle = styled.div`
  font-size: 2rem;
  font-weight: 600;
  line-height: 1.8rem;
`;

const StyledFlexWrapper = styled.div`
  margin-top: 1rem;
  width: 100%;
  display: flex;
  background-color: ${(props) => props.theme.color[props.backgroundColor]};
  color: ${(props) => props.theme.color[props.textColor]};
  flex-direction: ${(props) => (props.isWrapMobile ? "column" : "row")};
  & > *:not(:first-child) {
    margin-left: ${(props) => (props.isWrapMobile ? 0 : 0.4)}rem;
  }

  ${(props) => props.theme.responsive.desktop} {
    flex-direction: row;

    & > *:not(:first-child) {
      margin-left: 1rem;
    }
  }
`;

const StyledImageDescriptionWrapper = styled.div`
  flex: 1;
  margin-bottom: 1.6rem;
  ${(props) => props.theme.responsive.desktop} {
    margin-bottom: 0rem;
  }
`;

const ImageListModal = ({
  title,
  imageDescriptions,
  backgroundColor,
  isWrapMobile,
  textColor,
}) => {
  const intl = useIntl();
  return (
    <StyledWrapper backgroundColor={backgroundColor} textColor={textColor}>
      <StyledTitle>{get(title, intl.locale, "")}</StyledTitle>
      <StyledFlexWrapper isWrapMobile={isWrapMobile}>
        {imageDescriptions.map((imageDescription, i) => (
          <StyledImageDescriptionWrapper
            key={`imageList-imageDescription-${i}`}
          >
            <ImageDescription
              asset={get(imageDescription, "asset", null)}
              vimeoURL={get(imageDescription, "vimeoURL", null)}
              title={get(imageDescription, `title[${intl.locale}]`, "")}
              description={get(
                imageDescription,
                `description[${intl.locale}]`,
                ""
              )}
              link={get(imageDescription, "link", null)}
            />
          </StyledImageDescriptionWrapper>
        ))}
      </StyledFlexWrapper>
    </StyledWrapper>
  );
};

export default ImageListModal;

export const query = graphql`
  fragment imageListModal on STRAPI_ComponentBaseImageListModal {
    __typename
    id
    title {
      en
      es
      it
    }
    textColor {
      color
    }
    backgroundColor {
      color
    }
    isWrapMobile
    imageDescriptions {
      vimeoURL
      asset {
        url
        ext
        imageFile {
          childImageSharp {
            gatsbyImageData(layout: FULL_WIDTH)
          }
        }
      }
      title {
        en
        es
        it
      }
      link
      description {
        en
        es
        it
      }
    }
  }
`;
